<template>
    <div class="row justify-content-center align-items-center" id="register">
        <notifications></notifications>
        <div class="col-md-6 col-11">
            <card class="card-signup text-center" no-footer-line>
                <template slot="header">
                    <h4 class="card-title">Register</h4>
                </template>
                <!-- <div class="row"> -->

                    <form @submit.prevent class="form-horizontal">
                        <div class="row">
                            <div class="col-12">
                                <fg-input
                                    v-model="user.name"
                                    placeholder="Name"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <fg-input
                                    v-model="user.company"
                                    placeholder="Company"
                                    @keyup.enter.native="submit()"/>
                            </div>
                            <div class="col-12 col-md-6">
                                <fg-input
                                    v-model="user.jobRole"
                                    placeholder="Job role"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                 <fg-input
                                    v-model="user.businessChallenge"
                                    placeholder="What is your biggest challenge when planning business?"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                 <fg-input
                                    type="number"
                                    v-model="user.eventsNumber"
                                    placeholder="Nmber of events per year?"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <fg-input
                                    v-model="user.email"
                                    placeholder="E-Mail"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <fg-input
                                    v-model="user.phone"
                                    placeholder="Telephone"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <fg-input
                                    v-model="user.findUs"
                                    placeholder="Where did you find us ?"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <fg-input
                                    v-model="user.eventDescription"
                                    placeholder="Tell us more about your events and pain points"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <fg-input
                                    v-model="user.password"
                                    placeholder="Password"
                                    type="password"
                                    @keyup.enter.native="submit()"/>
                            </div>

                            <div class="col-12 col-md-6">
                                <fg-input
                                    v-model="user.passwordConfirmation"
                                    placeholder="Password Confirmation"
                                    type="password"
                                    @keyup.enter.native="submit()"/>
                            </div>
                        </div>

                        <checkbox v-model="agreed" class="text-left">
                            I agree to the
                            <a
                                href="#something"
                                @click.prevent="$store.commit('SHOW_DIALOG', 'termsAndConditions')">
                                    Terms and Conditions
                            </a>.
                        </checkbox>

                        <div class="row mt-3">
                            <div class="col-12">
                                <recaptcha
                                    :sitekey="$store.state.recaptcha"
                                    @verify="onRecaptchaVerify"
                                    ref="recaptcha"/>
                            </div>
                        </div>
                    </form>
                <!-- </div> -->
                <div slot="footer">
                    <n-button
                        @click.native="submit()"
                        :loading="loading"
                        class="btn btn-primary btn-round btn-lg">
                            Sign Up
                    </n-button>
                    <div class="d-flex justify-content-center">
                        <router-link :to="{ name: 'login' }">
                            <n-button type="neutral">Already Have an Account? Login</n-button>
                        </router-link>
                    </div>
                </div>
            </card>
        </div>

        <el-dialog
            title="Terms And Conditions"
            :visible.sync="$store.state.dialogs.termsAndConditions">
                <div v-html="$store.state.settings.termsAndConditions"></div>
        </el-dialog>
    </div>
</template>

<script>
import { Checkbox } from '@/components/now-ui'

export default {
    components: {
        Checkbox
    },
    data () {
        return {
            user: {
                name: '',
                company: '',
                jobRole: '',
                businessChallenge: '',
                eventsNumber: '',
                phone: null,
                email: '',
                findUs: '',
                eventDescription: '',
                password: '',
                passwordConfirmation: '',
                grecaptcha: ''
            },
            agreed: false,
            loading: false
        }
    },
    methods: {
        submit: async function () {
            if (!this.agreed) {
                this.$notify({ type: 'danger', message: 'Please agree to terms to proceed' })
                return
            }

            try {
                this.loading = true
                await this.$store.dispatch('signup', { data: this.user, host: `${window.location.protocol}//${window.location.host}` })
                this.$notify({ type: 'success', message: 'Successfully signed up, please check your email for verification!' })
                this.$router.push({ name: 'login' })
            } catch (e) {
                this.$refs.recaptcha.reset()
                console.log('error signing up')
            }

            this.loading = false
        },
        onRecaptchaVerify: function (grecaptcha) {
            this.user.grecaptcha = grecaptcha
        }
    }
}
</script>
